<template>

  <div style="display: flex; flex-direction: row">
    <slot name="extentSlot" ></slot>
    <div class="css_toot">
      <el-col style="width: 330px;">
        <el-row style="width: 100%; display: flex; flex-direction: row;">
          <div title="平移" class="mp_button" @click="iconclick(0)">
            <span class="element-icons" :style="{color:activeIndex==0?activeColor:normalColor}">&#xe622;</span>
          </div>
          <span class="diver_line">|</span>
          <div title="查询" class="mp_button" @click="iconclick(1)"><span  class="element-icons" :style="{color:activeIndex==1?activeColor:normalColor}">&#xe610;</span></div>
          <div title="面积测量" class="mp_button" @click="iconclick(2)"><span  class="element-icons" :style="{color:activeIndex==2?activeColor:normalColor}">&#xe65e;</span></div>
          <div title="距离测量" class="mp_button" @click="iconclick(3)"><span  class="element-icons" :style="{color:activeIndex==3?activeColor:normalColor}">&#xe604;</span></div>
          <div class="diver_line"><span>|</span></div>
          <div title="复位" class="mp_button" @click="iconclick(4)" ><span  class="element-icons" :style="{color:activeIndex==4?activeColor:normalColor}">&#xe6a8;</span></div>
          <!--<div class="mp_button" @click="iconclick(5)" ><span class="element-icons" :style="{color:activeIndex==5?activeColor:normalColor}">&#xe628;</span></div>-->
          <div title="清除" class="mp_button" @click="iconclick(5)"><span  class="element-icons" :style="{color:activeIndex==5?activeColor:normalColor}">&#xe60e;</span></div>
        </el-row>
        <el-row>
          <slot name="bottomSlot">
          </slot>
        </el-row>
      </el-col>
    </div>

  </div>
</template>

<script>


  export default {
    name: "MapTools",
    data(){
      return {
        activeIndex:0,
        activeColor:'red',
        normalColor:'gray'
      }
    },
    methods:{
      iconclick:function (menuIndex) {
        console.log("MapTools clicked & menuIndex = ",menuIndex);
        //将点击事件传递出去
       if(menuIndex==5)
        {
          this.$emit("mptClick","delete");
        }
        else if(menuIndex==4)
        {
          this.$emit("mptClick","fullMap");
        }
       else if(menuIndex==3)
       {
         this.$emit("mptClick","mLine");
         this.activeIndex = menuIndex;
       }
       else if(menuIndex==2)
       {
         this.$emit("mptClick","mPolygon");
         this.activeIndex = menuIndex;
       }
       else if(menuIndex==1)
       {
         this.$emit("mptClick","query");
         this.activeIndex = menuIndex;
       }
       else if(menuIndex==0)
       {
         this.$emit("mptClick","pan");
         this.activeIndex = menuIndex;
       }

      }
    }
  }
</script>

<style lang="scss">

  .diver_line
  {
    width: 20px;
    background-color: transparent;
    color: gray;
    font-size: 20px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    padding-top: 2px;
  }
  .element-icons
  {
    padding: 10px;
    background-color: transparent;
    cursor:pointer;
    color: gray;
    font-size: 20px;
  }


  .mp_button
  {
    border: none;
    width: 50px;
    height: 40px;
    padding: 0px;

    /*flex 布局*/
    display: flex;
    /*实现垂直居中*/
    align-items: center;
    /*!*实现水平居中*!*/
    justify-content: center;

    cursor:pointer;
  }

  .css_toot{
    /*flex 布局*/
    display: flex;
    direction: ltr;
    justify-content: flex-start;
    padding: 0px 5px;
    height: 40px;
    line-height: 40px;
    border: solid 1px lightgray;
    border-radius: 5px;
    text-align: left;
    background-color: white;
  }


</style>



// WEBPACK FOOTER //
// src/components/map/MapTools.vue